import { AddBeneficiary, Loader, ManageBeneficiaries, ModalParts } from 'BreetComponents';
import { selectBeneficiaries, useAppSelector, useGetBeneficiariesQuery } from 'BreetRedux';
import { useCallback } from 'react';

import type { IStageBeneficiary } from './StageBeneficiary.helpers';

const StageBeneficiary = <T extends string>({
	formStage,
	beneficiaryStage,
	manageBeneficaryStage,
	rootStage,
	stageTitleObj,
	children,
}: IStageBeneficiary<T>) => {
	const { isLoading: getBeneficiariesLoading } = useGetBeneficiariesQuery();

	const beneficiaries = useAppSelector(selectBeneficiaries);

	const { navigator, isStageActive, stageTitle } = formStage;

	const onAddBeneficiarySuccess = useCallback(() => {
		navigator.reset();
		navigator.goTo(rootStage)();
	}, [navigator, rootStage]);

	if (getBeneficiariesLoading) return <Loader />;

	return (
		<ModalParts.Wrapper
			title={stageTitle}
			root={stageTitleObj[!beneficiaries.length ? beneficiaryStage : rootStage]}
			handleBackLink={navigator.historyBack}
			rightSheet
		>
			<ModalParts.Stage hide={!isStageActive(beneficiaryStage)}>
				<AddBeneficiary
					intent='initiate a withdrawal'
					noBeneficiary={!beneficiaries.length}
					onSuccess={onAddBeneficiarySuccess}
				/>
			</ModalParts.Stage>
			<ModalParts.Stage hide={!isStageActive(manageBeneficaryStage)}>
				<ManageBeneficiaries onAddNewBeneficiary={navigator.goTo(beneficiaryStage)} />
			</ModalParts.Stage>
			{children}
		</ModalParts.Wrapper>
	);
};

export default StageBeneficiary;
